import { commitMutation, graphql } from 'react-relay';
import environment from '../data/environment';

const mutation = graphql`
  mutation CreateJobPdfExportMutation(
    $input: CreateJobPdfExportInput!
  ) {
    createJobPdfExport(input: $input) {
      job {
        finishedOn
        processedOn
        id
        mongoId
        type
        jobId
        failedReason
        filename
        returnvalue
      }
    }
  }
`;

function commit({
  reportId,
  exportId,
  filename,
  type,
  from,
  to,
  devices,
  selectedTags,
  questionFilters,
}, callback) {
  commitMutation(
    environment,
    {
      mutation,
      variables: {
        input: {
          reportId,
          exportId,
          filename,
          type,
          from,
          to,
          devices,
          selectedTags,
          questionFilters,
        },
      },
      onCompleted: (res, errors) => {
        if (errors) {
          return callback(errors);
        }
        callback(null, res.createJobPdfExport.job);
      },
      onError: (err) => {
        callback(err);
      },
    },
  );
}

export default { commit };



// WEBPACK FOOTER //
// ./src/mutations/CreateJobPdfExportMutation.js